import './project.scss';

// `$` is provided by esbuild externalGlobalPlugin → window.$ (vendor.bundle loads first).
$(document).on('click', 'a.device-tree-toggle', (event) => {
    event.preventDefault();
    $(event.currentTarget).closest('.device-tree-branch').toggleClass('menu-open');
});
